import { APICallV4Post } from 'reactApp/api/APICall';

export interface VkMusicBundleCheckPossibilityQueryParams {
    vkId: number;
}

export interface VkMusicBundleCheckPossibilityResponse {
    success: boolean;
    data?: {
        payable_subscription_available: boolean;
        trial_subscription_available: boolean;
    };
    error?: {
        description: string;
        code: number;
    };
}

export class VkMusicBundleCheckPossibilityAPICall extends APICallV4Post<
    VkMusicBundleCheckPossibilityResponse,
    VkMusicBundleCheckPossibilityQueryParams
> {
    _method = 'billing/vkmusic/check-possibility';
}
